/**
 * Helpers para productos proyectados desde master_catalog 0E3.
 */

export function isProductoPendienteDePrecio(producto) {
  if (!producto) return false;
  const precio = parseFloat(producto.precio_venta ?? producto.precio ?? 0);
  if (precio > 0 && producto.requiere_precio !== true) return false;
  if (producto.requiere_precio === true && precio <= 0) return true;
  if (producto.createdFrom === 'master_catalog_0e3' && precio <= 0) return true;
  return false;
}

export function getProductoPendientePrecioLabel() {
  return 'Pendiente de precio';
}

export function isProductoMasterImportado(producto) {
  if (!producto) return false;
  return producto.createdFrom === 'master_catalog_0e3' || Boolean(producto.master_catalog_ean);
}

export function debeAbrirActivacionMaster(producto) {
  return isProductoMasterImportado(producto) && isProductoPendienteDePrecio(producto);
}

export function getEstadoProductoMaster(producto, stockSucursal = null) {
  if (!producto) return 'pendiente_precio';
  if (isProductoPendienteDePrecio(producto)) return 'pendiente_precio';
  const precio = parseFloat(producto.precio_venta ?? producto.precio ?? 0);
  const stock = parseFloat(
    stockSucursal ?? producto.stock_sucursal ?? producto.stock_actual ?? producto.stock?.cantidad ?? 0
  ) || 0;
  if (precio > 0 && stock <= 0) return 'sin_stock';
  if (precio > 0) return 'listo';
  return 'pendiente_precio';
}

export function getMensajeActivacionProducto(estado) {
  if (estado === 'listo') return 'Producto listo para vender';
  if (estado === 'sin_stock') return 'Sin stock';
  return 'Pendiente de precio';
}

export function getEstadoProductoMasterLabel(estado) {
  if (estado === 'listo') return 'Listo para vender';
  if (estado === 'sin_stock') return 'Sin stock';
  return 'Pendiente de precio';
}

/** Colores e iconos unificados (Fase 4) */
export const ESTADO_MASTER_THEME = {
  pendiente_precio: {
    badgeClass: 'bg-orange-100 text-orange-800 border-orange-200',
    dotClass: 'bg-orange-500',
    icon: 'clock',
    tooltip: 'Falta cargar precio de venta'
  },
  sin_stock: {
    badgeClass: 'bg-yellow-100 text-yellow-900 border-yellow-200',
    dotClass: 'bg-yellow-500',
    icon: 'box',
    tooltip: 'Tiene precio pero sin stock en sucursal'
  },
  listo: {
    badgeClass: 'bg-green-100 text-green-800 border-green-200',
    dotClass: 'bg-green-500',
    icon: 'check',
    tooltip: 'Precio y stock listos para vender'
  }
};

export function getEstadoProductoMasterTheme(estado) {
  return ESTADO_MASTER_THEME[estado] || ESTADO_MASTER_THEME.pendiente_precio;
}

export function resolveEstadoProductoMaster(producto, stockSucursal = null) {
  const estado = getEstadoProductoMaster(producto, stockSucursal);
  return {
    estado,
    label: getEstadoProductoMasterLabel(estado),
    theme: getEstadoProductoMasterTheme(estado),
    mensaje: getMensajeActivacionProducto(estado)
  };
}

/**
 * Métricas de activación del catálogo importado (Fase 5).
 */
export function computeCatalogActivationMetrics(productos = []) {
  const master = productos.filter(isProductoMasterImportado);
  const total = master.length;
  let pendientes = 0;
  let listos = 0;
  let sinStock = 0;

  master.forEach((p) => {
    const estado = getEstadoProductoMaster(
      p,
      p.stock_actual ?? p.stock_sucursal ?? p.stock?.cantidad
    );
    if (estado === 'pendiente_precio') pendientes += 1;
    else if (estado === 'sin_stock') sinStock += 1;
    else if (estado === 'listo') listos += 1;
  });

  const activados = listos + sinStock;
  const porcentaje = total > 0 ? Math.round((activados / total) * 100) : 0;

  return {
    total,
    pendientes,
    listos,
    sinStock,
    activados,
    porcentaje
  };
}
